import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import classNames from "classnames";
import { validateInputText } from "../../../utilities/ValidateUtil";
// import { validateInputText } from '../../../utilities/ValidateUtil';

export default function P402Dialog({ dialog, setDialog, staffType, data, submitForm, submitted }) {
    const [formObject, setformObject] = useState({});
    useEffect(() => {
        if (dialog.dialog === true && dialog.action === "แก้ไข") {
            setformObject(dialog.data);
        } else {
            setformObject({
                contractorCode: data.contractorCode,
                contractorName: data.contractorName,
                staffName: "",
                staffPositionCode: "",
                staffTelephone: "",
                updateUserName: "",
                updateDt: "",
            });
        }
    }, [dialog.data]);

    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button
                    // label={dialog.action}
                    label={"บันทึก"}
                    icon="pi pi-save"
                    onClick={() => submitForm(formObject)}
                    autoFocus
                    className="p-button p-button-success"
                // style={{width:150}}
                />
                <Button
                    label="ยกเลิก"
                    icon="pi pi-times"
                    onClick={() => setDialog(false)}
                    className="p-button-danger p-button"
                // style={{width:150}}
                />
                {/* {
                    dialog.action && dialog.action === 'แก้ไข'?(
                        <Button 
                            label="ลบรายการ" icon="pi pi-trash" 
                            onClick={() => submitForm(formObject,'ลบรายการ')} 
                            onClick = {()=>onDelData()}
                            className="p-button p-button-danger"
                            // style={{width:150}} 
                        />
                    ):('')
                } */}
            </div>
        );
    };

    const onDelData = () => {
        submitForm(formObject, "ลบรายการ");
    };

    const onHide = () => {
        setDialog(false);
        setformObject({});
    };

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setformObject({
            ...formObject,
            [`${key}`]: val,
        });
    };

    return (
        <>
            <Dialog header="เจ้าหน้าที่บริษัทคู่สัญญา" visible={dialog.dialog} style={{ width: "45vw" }} className="p-fluid ___widthDialog" footer={renderFooter()} onHide={() => onHide()} blockScroll={true} maximizable={true}>
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-col-12 ">
                        <label>รหัสบริษัทคู่สัญญา</label>
                        <InputText value={formObject.contractorCode} disabled maxLength="500" />
                    </div>

                    <div className="p-col-12">
                        <label>ชื่อบริษัทคู่สัญญา</label>
                        <InputText value={formObject.contractorName} disabled maxLength="500" />
                    </div>

                    <div className="p-col-12">
                        <label>
                            ชื่อ - นามสกุล<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText value={formObject.staffName} className="p-invalid" onChange={(e) => onInputTextChange(e, "staffName")} maxLength="500" />
                        {submitted && !formObject.staffName && validateInputText("staffName", "ชื่อ - นามสกุล")}
                    </div>

                    <div className="p-col-12">
                        <label>
                            ตำแหน่ง<span style={{ color: "red" }}>*</span>
                        </label>
                        <Dropdown value={formObject.staffPositionCode} options={staffType} optionLabel="staffTypeDesc" optionValue="staffTypeCode" className="p-invalid" filter appendTo={document.body} onChange={(e) => onInputTextChange(e, "staffPositionCode")} />
                        {submitted && !formObject.staffType && validateInputText("staffType", "ตำแหน่ง")}
                    </div>

                    <div className="p-col-12">
                        <label>
                            เบอร์ติอต่อ<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText value={formObject.staffTelephone} className="p-invalid"
                            onChange={(e) => onInputTextChange(e, "staffTelephone")} maxLength="500" />
                        {submitted && !formObject.staffTelephone && validateInputText("staffTelephone", "เบอร์ติอต่อ")}
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <label htmlFor="cb1">สถานะ</label>
                        <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                            <RadioButton inputId="status_1" name="status" value="A" onChange={(e) => onInputTextChange(e, "status")} checked={formObject.status === "A" || formObject.status === undefined} className={classNames({ "p-invalid": submitted && !formObject.status })} />
                            <label htmlFor="appointment_location1" style={{ marginRight: ".5rem" }}>
                                ใช้งาน
                            </label>
                            <RadioButton
                                inputId="status_2"
                                name="status"
                                value="I"
                                onChange={(e) => onInputTextChange(e, "status")}
                                checked={formObject.status === "I"}
                                // className="p-invalid"
                                className={classNames({ "p-invalid": submitted && !formObject.status })}
                            />
                            <label htmlFor="appointment_location2" style={{ marginRight: ".5rem" }}>
                                ไม่ใช้งาน
                            </label>
                        </div>
                        {submitted && !formObject.status && validateInputText("status", "สถานะ")}
                    </div>
                </div>
            </Dialog>
        </>
    );
}
